import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_RETAIL_ADD, URL_RETAIL_GET_LIST, URL_RETAIL_GET_DETAIL, URL_RETAIL_EDIT, URL_RETAIL_GET_LIST_ENABLE, URL_RETAIL_CHECK_HNKID } from "../../setup/config_beer";

export function api_getRetailList ({mReqRetailList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRetailList, token}), 
      url: URL_RETAIL_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getRetailListEnable ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_RETAIL_GET_LIST_ENABLE, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addRetail ({isAdd=true, Retail, InCharges, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: {Retail, InCharges}, token}), 
      url: isAdd?URL_RETAIL_ADD:URL_RETAIL_EDIT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getRetailDetail ({mReqRetailDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRetailDetail, token}), 
      url: URL_RETAIL_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkRetailHNKID ({mRespRetail, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespRetail, token}), 
      url: URL_RETAIL_CHECK_HNKID, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}